import { TwinSmartAsset } from '../models/application.interface';

export const ShipTwinSmartAsset: TwinSmartAsset = {
  singular: { EN: 'Vessel' },
  plural: { EN: 'Vessels' },
};
